import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from './client.service';

export interface CategoryModel {
  id: number;
  name: string;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
}

@Injectable({ providedIn: 'root' })
export class CategoryService {
  private readonly client = inject(ClientService);

  list(): Observable<CategoryModel[]> {
    return this.client.get<CategoryModel[]>('category');
  }
}
